findFlag